module.exports = __webpack_public_path__ + "img/banner5.9580b721.png";